import { HCP_CUBE_NAME } from '@/api/hcp';
import { GetOptionsQueryFunction } from '@/types/cube';
import { FilterConfigDynamic } from '@/types/filter';
import { toStringOrNull } from '@/utils/cube';
import { HCP_PROFESSION_FILTER_LIMIT } from '../../filterDefaultLimits';

const HCP_PROFESSION_OPTIONS: GetOptionsQueryFunction = ({ sourceCube }) => ({
  dimensions: [`${sourceCube}.type`],
  limit: HCP_PROFESSION_FILTER_LIMIT,
});

const hcpProfessionFilter: FilterConfigDynamic = {
  label: 'global.filters.formControls.hcpTypeLabel',
  sourceCube: HCP_CUBE_NAME,
  defaultValue: [],
  getOptionsQuery: HCP_PROFESSION_OPTIONS,
  mapResult: result => {
    const value = toStringOrNull(result[`${HCP_CUBE_NAME}.type`]);
    if (value === null) return null;
    return { value, label: value };
  },
  type: 'multiselect',
  clearable: true,
  placeholder: 'global.filters.formControls.hcpTypePlaceholder',
  searchable: true,
  applyFilter: value => {
    const v = value as string[];
    return {
      member: `${HCP_CUBE_NAME}.type`,
      operator: 'equals',
      values: [...v],
    };
  },
};

export default hcpProfessionFilter;
